/**
 * Created by marvin on 26.11.15.
 */
import React = require("react");
import Paper from "material-ui/Paper";
import CircularProgress from "material-ui/CircularProgress";

import {Layout} from "./ProgressTask";

import SuccessIcon from "material-ui/svg-icons/navigation/check";
import ErrorIcon from "material-ui/svg-icons/content/clear";

export enum Status {
    WAITING,
    RUNNING,
    FINISHED,
    FAILED,
    STOPPED
}

export function checkStatus(element: any, originalState: any, payload: any): Status {

    if (payload.identifier === element.props.identifier) {
        return payload.state;
    } else if (element.props.followedBy.indexOf(payload.identifier) !== -1 &&
        (payload.state !== Status.WAITING && payload.state !== Status.RUNNING)) {
        return Status.FINISHED;
    }

    return originalState;
}

interface ProgressStatusProps extends React.Props<ProgressStatus> {
    value: Status;
    index: number;
    layout?: Layout;
}

export default class ProgressStatus extends React.Component<ProgressStatusProps, {}> {

    styles = {
        progress: {
            margin: "auto"
        },
        paper: {
            margin: "auto",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        } as React.CSSProperties,
        active: {
            color: "white",
            backgroundColor: "#2196f3"
        }
    };

    constructor(props: ProgressStatusProps) {
        super(props);

        this.props = {
            value: this.props.value ? this.props.value : Status.WAITING,
            layout: this.props.layout ? this.props.layout : Layout.SPINNER,
            index: this.props.index
        };
    }

    render(): JSX.Element {
        switch (this.props.value) {
            case Status.WAITING:
                return this.waitingState();
            case Status.RUNNING:
                return this.runningState();
            case Status.FINISHED:
                return this.finishState();
            case Status.FAILED:
                return this.failedState();
            case Status.STOPPED:
                return this.stoppedState();
            default:
                return null;
        }
    }

    private waitingState(): JSX.Element {
        switch (this.props.layout) {
            case Layout.SPINNER:
                return (
                    <CircularProgress mode="determinate"
                                      value={70}
                                      size={0.6}
                                      color="#e0e0e0"
                                      style={this.styles.progress} />
                );

            case Layout.STEPS:
                return (
                    <Paper zDepth={1} circle={true} style={this.styles.paper}>
                        {this.props.index}
                    </Paper>
                );

            default:
                return null;
        }
    }

    private runningState(): JSX.Element {
        switch (this.props.layout) {
            case Layout.SPINNER:
                return (
                    <CircularProgress mode="indeterminate"
                                      size={0.6}
                                      color={this.styles.active.backgroundColor}
                                      style={this.styles.progress} />
                );

            case Layout.STEPS:
                let styles = Object.assign({}, this.styles.paper, this.styles.active);
                return (
                    <Paper zDepth={2} circle={true} style={styles}>
                        {this.props.index}
                    </Paper>
                );

            default:
                return null;
        }
    }

    private finishState(): JSX.Element {
        return (
            <Paper zDepth={1} circle={true} style={this.styles.paper}>
                <SuccessIcon color="#4ccd1a" />
            </Paper>
        );
    }

    private failedState(): JSX.Element {
        return (
            <Paper zDepth={1} circle={true} style={this.styles.paper}>
                <ErrorIcon color="#ff0000" />
            </Paper>
        );
    }

    private stoppedState(): JSX.Element {
        return (
            <Paper zDepth={1} circle={true} style={this.styles.paper}>
                <ErrorIcon color="grey" />
            </Paper>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/progress-dialog/ProgressStatus.tsx
 **/